import React, {createContext, ReactNode} from 'react';

interface DocumentContextInterface {
    documentId: string;
    saveDocument: () => void;
}

const DocumentContext = createContext<DocumentContextInterface>({documentId: '', saveDocument: () => {}});

export class DocumentContextProvider extends React.Component<{
    children: ReactNode;
    documentId: string;
    saveDocument: () => void;
}> {
    render() {
        return (
            <DocumentContext.Provider
                value={{documentId: this.props.documentId, saveDocument: this.props.saveDocument}}
            >
                {this.props.children}
            </DocumentContext.Provider>
        );
    }
}

export const useDocumentContext = () => {
    return React.useContext(DocumentContext);
};
